import React, { useState } from 'react';

import styled from 'styled-components';
import { GIButton, Modal } from 'app-components';

import Form from '../../../lib/wrappers/Form';
import UniversalInput from '../../../lib/wrappers/UniversalInput';
import { INPUT_TYPES } from '../../../constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '../../../constants/inputs/validationTypes';
import { TEXTAREA_MAX_LENGTH, TEXTAREA_MIN_LENGTH } from '../../../constants/enrollments/enrollments.constants';
import useQLEMN from '../hooks/useQLEMN';
import { useAppDispatch } from '@hooks/index';
import { ModalContextType } from '../../../contexts/modalContext';

const StyledAlertWrapper = styled.div`
    .gi-alert {
        padding: 10px;
    }
`;

export const StyledTextAreaContainer = styled.div`
    .gi-textarea__label {
        display: none;
    }
    .gi-textarea__input {
        flex: 1;
        width: 100%;
        padding: 10px;
        height: 5rem !important;
        font-size: Medium;
    }
    .gi-textarea {
        display: flex;
        width: 100%;
        text-align: left;
        padding-left: 0;
        flex-direction: row;
        flex-wrap: nowrap;
        color: ${({ theme }) => theme.primaryMain};
    }
`;

interface IModalProps extends ModalContextType {
    applicantEventId: string;
    caseNumber: string;
}

const QleOverrideModal = ({ closeModal, applicantEventId, caseNumber }:IModalProps) => {
    const [overrideComment, setOverrideComment] = useState({ overrideCommentText: '' });
    const { submitOverrideComment } = useQLEMN();
    const dispatch = useAppDispatch();

    const onClose = () => {
        closeModal('overrideQLEDocumentsModal');
    };

    const handleSubmit = () => {
        setOverrideComment({ overrideCommentText: '' });
        dispatch(
            submitOverrideComment({
                applicantEventId,
                comment: overrideComment.overrideCommentText,
                caseNumber,
            }),
        );
        onClose();
    };

    return (
        <Modal id="overrideReasonModal">
            <Modal.Header
                id="overrideReasonModalHeader"
                titleId="cap.applications.modal.overrideReason"
                onHide={onClose}
            />
            <Modal.Body>
                <Form formName="override-DMI-verification" data-testid="override-DMI-verification">
                    <StyledAlertWrapper>
                        <StyledTextAreaContainer data-testid="textarea-container">
                            <UniversalInput
                                inputData={{
                                    isInputRequired: false,
                                    type: INPUT_TYPES.TEXTAREA,
                                    name: 'overrideCommentText',
                                    value: overrideComment.overrideCommentText,
                                    liClass: ['text-left'],
                                    currentData: overrideComment,
                                    rows: 2,
                                    validationType: VALIDATION_TYPES.LENGTH,
                                    valuesToMatch: [TEXTAREA_MIN_LENGTH, TEXTAREA_MAX_LENGTH],
                                }}
                                errorClasses={['margin-l-0']}
                                inputActions={{
                                    onFieldChange: ({ overrideCommentText }) => {
                                        setOverrideComment(prev => ({ ...prev, overrideCommentText }));
                                    },
                                }}
                                data-testid="textarea-input"
                            />
                        </StyledTextAreaContainer>
                    </StyledAlertWrapper>
                </Form>
            </Modal.Body>
            <Modal.Controls>
                <GIButton id="closeButton" onClickHandler={onClose} variant="secondary" labelId="button.close" />
                <GIButton
                    id="submitButton"
                    onClickHandler={handleSubmit}
                    variant="primary"
                    labelId="button.submit"
                    isDisabled={!overrideComment.overrideCommentText}
                />
            </Modal.Controls>
        </Modal>
    );
};

export default QleOverrideModal;
